import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpClientService } from './http-client.service';


@Injectable({
  providedIn: 'root'
})
export class ContadorService {

  urlApi = environment.api;
  token = sessionStorage.getItem('loginAuth');
  
  constructor(private http: HttpClientService) { }   

  getContador(cnpj: any): Promise<any> {
    return this.http.get( this.urlApi + '/contador?cnpj=' + cnpj.toUpperCase())
    .toPromise()
    .then(response => response);
  }

  getDadosDoCRC(cpfCnpj: any): Promise<any> {
    return this.http.get( this.urlApi + '/contador/'+ cpfCnpj.toUpperCase() + '/cpf-cnpj')
    .toPromise()
    .then(response => response);
  }

  postContador(body){
    return this.http.post( this.urlApi + '/contador', body)
    .toPromise()
    .then(response => response);
  }

  putContador(id, body){ 
    return this.http.put( this.urlApi + '/contador/' + id, body)
    .toPromise()
    .then(response => response);
  }

  deleteContador(id){
    return this.http.delete( this.urlApi + '/contador/' + id)
    .toPromise()
    .then(response => response);
  }
  
}
